<script setup lang="ts">
import type { Section } from './report-typing';

import { useUpdatedReportStore } from '@src/store/report-store';
import { computed } from 'vue';

import FieldGroupSectionRenderer from './FieldGroupSectionRenderer.vue';
import FreeTextSectionRenderer from './FreeTextSectionRenderer.vue';
import HeaderSectionRenderer from './HeaderSectionRenderer.vue';
import ImageGridSectionRenderer from './ImageGridSectionRenderer.vue';
import RichTextSectionRenderer from './RichTextSectionRenderer.vue';
import StatRowSectionRenderer from './StatRowSectionRenderer.vue';
import TableSectionRenderer from './TableSectionRenderer.vue';

const props = defineProps<{
  section: Section;
}>();

const reportStore = useUpdatedReportStore();

const kindToComponent = {
  header: HeaderSectionRenderer,
  fieldGroup: FieldGroupSectionRenderer,
  freeText: FreeTextSectionRenderer,
  richText: RichTextSectionRenderer,
  statRow: StatRowSectionRenderer,
  table: TableSectionRenderer,
  imageGrid: ImageGridSectionRenderer,
} as const;

const sectionComponent = computed(() => {
  return (kindToComponent[props.section.kind] ?? null) as any;
});

const sectionStyle = computed(() => {
  const template = reportStore.getTemplate();
  if (!template || props.section.kind === 'fieldGroup') {
    return {};
  }
  return {
    marginBottom: `${template.theme.spacing.sectionGap}px`,
  };
});
</script>

<template>
  <component :is="sectionComponent" :section="section" :style="sectionStyle" />
</template>
